/** 前台 Middleware */
export default defineNuxtRouteMiddleware((to) => {
  const localePath = useLocalePath()

  const authStore = useAuthStore()
  const { accountNo } = storeToRefs(authStore)

  if (!accountNo.value) {
    return navigateTo(
      localePath({
        path: '/sign',
        query: {
          from: to.path
        }
      })
    )
  }
})
